export default __webpack_public_path__ + "static/media/grab-rentals-mobile.80993e85.png";